export const getFactionUnitSkinIconPath = (unitTypeId, factionId) => {
  if (!unitTypeId || !factionId) {
    return `/img/other/strategikon_bust.png`;
  }
  return `/img/factions/unit_icons/${unitTypeId}_${factionId}.png`;
}
